import { Briefcase, Cpu, Dumbbell, GraduationCap, Palette } from "lucide-react";

import type { FieldPreset } from "./types";

const APPEARANCE_PRESETS: FieldPreset[] = [
  {
    value: "professional",
    label: "The Professional",
    icon: Briefcase,
  },
  {
    value: "creative",
    label: "The Creative",
    icon: Palette,
  },
  {
    value: "mentor",
    label: "The Mentor",
    icon: Dumbbell,
  },
  {
    value: "scholar",
    label: "The Scholar",
    icon: GraduationCap,
  },
  { value: "cyber", label: "The Cyber", icon: Cpu },
];

const BACKGROUND_PRESETS: FieldPreset[] = [
  { value: "podcast_studio", label: "🎙️ Podcast Studio" },
  { value: "office", label: "🏢 Office" },
  { value: "nature", label: "🌿 Nature" },
  { value: "neon", label: "💜 Neon" },
  { value: "minimalist", label: "⬜ Minimalist" },
];

export const PRESETS: Record<string, FieldPreset[]> = {
  archetypes: APPEARANCE_PRESETS,
  backgrounds: BACKGROUND_PRESETS,
};

export enum FieldId {
  PERSON_IMAGE = "person_image",
  SCRIPT = "script",
}
